import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../lib/api";

export default function AboutPage() {
  return (
    <div className="py-16 md:py-24" data-testid="about-page">
      <div className="container-vdz">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="eyebrow mb-5">Despre Vis de Zi</div>
            <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05]" style={{ color: "var(--vdz-navy)" }}>
              Povestea unui vis colorat de tine.
            </h1>
            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed opacity-85">
              <p>
                <strong className="font-serif-display text-xl gold-text">VIS DE ZI</strong> este un brand creativ românesc construit cu grijă, răbdare și dragoste
                în jurul coloratului pentru adulți — un ritual blând care îți oferă o oră doar pentru tine.
              </p>
              <p>
                Fiecare carte este concepută ca o colecție de momente de respirație. Ilustrațiile sunt
                feminine, atmosferice, inspirate din ilustrația de modă, din universurile fantastice și
                din frumusețea tăcută a reveriei.
              </p>
              <p>
                Vis de Zi nu este o carte de colorat pentru copii. Este o invitație elegantă adresată
                femeilor care au nevoie de un moment doar al lor — să încetinească, să respire, să viseze.
              </p>
            </div>
            <div className="gold-divider my-10"><span className="eyebrow">Creat de</span></div>
            <div>
              <h2 className="font-serif-display text-3xl gold-text">Alina Stancu</h2>
              <p className="mt-3 opacity-80 leading-relaxed max-w-md">
                Fondatoarea Vis de Zi. Artistă și visătoare. Alina creează fiecare ilustrație cu intenția
                de a oferi o pauză frumoasă fiecărei femei care deschide cartea.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 blur-3xl opacity-30" style={{ background: "radial-gradient(circle, var(--vdz-gold) 0%, transparent 70%)" }} />
            <div className="gold-frame relative">
              <img src={BRAND.logo} alt="Alina Stancu — VIS DE ZI" className="w-full" />
            </div>
          </div>
        </div>

        {/* Values */}
        <section className="mt-24 md:mt-32">
          <div className="text-center max-w-xl mx-auto mb-14">
            <div className="eyebrow mb-3">Valorile noastre</div>
            <h2 className="font-serif-display text-4xl md:text-5xl" style={{ color: "var(--vdz-navy)" }}>Frumusețea prin încetinire.</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { t: "Original 100%", d: "Toate ilustrațiile sunt create exclusiv pentru Vis de Zi. Nu reproducem, nu copiem — doar visăm." },
              { t: "Hârtie premium", d: "Cărțile sunt printate pe hârtie groasă, perfectă pentru creioane, markere și pixuri gel." },
              { t: "Creat în România", d: "De la primul contur la cartea printată — totul se întâmplă aici, cu drag și cu grijă." },
            ].map((v, i) => (
              <div key={i} className="p-8 bg-white border" style={{ borderColor: "var(--vdz-cream-border)" }}>
                <div className="w-10 h-10 mb-5 flex items-center justify-center gold-text" style={{ background: "var(--vdz-cream-warm)" }}>
                  0{i + 1}
                </div>
                <h3 className="font-serif-display text-2xl" style={{ color: "var(--vdz-navy)" }}>{v.t}</h3>
                <p className="mt-3 opacity-75 text-sm leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </section>

        <div className="text-center mt-20">
          <Link to="/carti" className="btn-gold" data-testid="about-cta-button">Descoperă cărțile</Link>
        </div>
      </div>
    </div>
  );
}
